import { setOrgList } from 'app/store/features/orgSelectSlice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';

export const useParseOrgs = () => {
  const dispatch = useDispatch();
  const orgs = useSelector((state) => state.orgSelect.orgs);

  // Organisation names come in a URL encoded object in case of OIDC login, the function is used to make sure names display properly
  const parseOrgName = (orgName) => {
    try {
      return decodeURIComponent(orgName.replace(/\+/g, ' '));
    } catch (e) {
      console.error("Failed to parse org name:", e);
      return orgName;
    }
  };

  const result = useMemo(() => {
    const cookies = new Cookies();
    const cookieValue = cookies.get('nic-osm');
    cookies.remove('nic-osm');

    // If nic-osm cookie does not exist redirect to home page
    if (!cookieValue) {
      if(orgs?.length > 1){
        return {redirect: false, orgs}
      }
      return { redirect: true, orgs: [] }
    };

    try {
      const orgsObj = cookieValue.organizations;

      if (!orgsObj || Object.keys(orgsObj)?.length === 0) {
        return { redirect: true, orgs: [] };
      }

      const orgsArray = Object.entries(orgsObj).map(([id, name]) => ({
        id,
        name: parseOrgName(name),
      }));
      dispatch(setOrgList(orgsArray));
      const redirect = orgsArray.length <= 1;
      return { redirect, orgs: orgsArray };
    } catch (err) {
      console.error('Failed to parse nic-osm cookie:', err);
      return { redirect: true, orgs: [] };
    }
  }, []);

  return result;
};
